/*
 * Event groups the running agent turn is writing to. While a group is listed,
 * isEventGroupLocked() reports it as locked, so every manual edit path (and
 * Undo into it) is blocked until the turn ends. Agent executors check the
 * real lock state instead (see agent/guards.js).
 */

export const agentEditLock = $state({
    /** @type {string[]} event group ids */
    groupIds: [],
});

export function isGroupAgentLocked(groupId) {
    return Boolean(groupId) && agentEditLock.groupIds.includes(groupId);
}

export function addAgentLock(groupId) {
    if (groupId && !agentEditLock.groupIds.includes(groupId)) {
        agentEditLock.groupIds.push(groupId);
    }
}

export function clearAgentLocks() {
    agentEditLock.groupIds = [];
}
